class GiftBoxModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['modal', 'close', 'backdrop']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.showModal = this.showModal.bind(this)
    this.onModalTriggerClick = this.onModalTriggerClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onEscapePress = this.onEscapePress.bind(this)

    this.listeners.add(
      this.externalEls?.modalTrigger?.element,
      'click',
      this.showModal,
    )
    this.listeners.add(this.els.close.element, 'click', this.onCloseClick)
    this.listeners.add(this.els.backdrop.element, 'click', this.onCloseClick)
    this.listeners.add(document, 'keyup', this.onEscapePress)

    this.listeners.add(document, 'click', this.onModalTriggerClick.bind(this))
  }

  onModalTriggerClick (event) {
    if (!event.target.closest(this.externalEls?.modalTrigger?.selector)) return

    event.preventDefault()

    this.showModal()
  }

  showModal () {
    this.els.modal.element.setAttribute('data-hidden', false)
  }

  onCloseClick () {
    this.els.modal.element.setAttribute('data-hidden', true)
  }

  onEscapePress (event) {
    if (event.key === 'Escape') {
      this.els.modal.element.setAttribute('data-hidden', true)

      this.onCloseClick()
    }
  }
}

if (!customElements.get('gift-box-modal')) {
  customElements.define('gift-box-modal', GiftBoxModal)
}
